import { HarmCategory, HarmBlockThreshold } from "@google/genai";

export const ASK_AI_PROMPT_TYPES = {
    SCREENSHOT_ASK: "SCREENSHOT_ASK",
    TEXT_ONLY: "TEXT_ONLY",
};

export const ASK_AI_MESSAGE_TYPES = {
    USER: "USER",
    AI: "AI",
    SMART_ACTIONS: "SMART_ACTIONS",
};

export const GEMINI_API_KEY = process.env.REACT_APP_GEMINI_API_KEY || "";
export const GEMINI_MODEL = "gemini-2.5-flash";

/**
 * Gemini Safety Settings Configuration
 * All categories use consistent BLOCK_LOW_AND_ABOVE threshold
 * for maximum protection in customer-facing application
 * Issue #8: Fixed inconsistent safety filter thresholds
 */
export const GEMINI_SAFETY_SETTINGS = [
    {
        category: HarmCategory.HARM_CATEGORY_HARASSMENT,
        threshold: HarmBlockThreshold.BLOCK_LOW_AND_ABOVE,
    },
    {
        category: HarmCategory.HARM_CATEGORY_HATE_SPEECH,
        threshold: HarmBlockThreshold.BLOCK_LOW_AND_ABOVE, // FIXED: Was BLOCK_ONLY_HIGH
    },
    {
        category: HarmCategory.HARM_CATEGORY_SEXUALLY_EXPLICIT,
        threshold: HarmBlockThreshold.BLOCK_LOW_AND_ABOVE,
    },
    {
        category: HarmCategory.HARM_CATEGORY_DANGEROUS_CONTENT,
        threshold: HarmBlockThreshold.BLOCK_LOW_AND_ABOVE,
    },
];

// System instruction for troubleshooting assistant
// IMPORTANT: Responses must be BRIEF (50-100 words max)
export const GEMINI_SYSTEM_INSTRUCTION = `You are an AI assistant helping support agents during live video sessions. You analyze images, identify issues, and provide BRIEF, actionable troubleshooting guidance.

=== CRITICAL: RESPONSE LENGTH ===
- ALL responses must be 50-100 words MAXIMUM
- Use bullet points, not paragraphs
- No verbose explanations or introductions
- Be direct and actionable

WHEN AN IMAGE IS PROVIDED:
Use bullet points for:
• **Extracted Data**: Serial/Model numbers/Barcode/QR DataVisible Text / Identifiers (if visible)
• **Assessment**: 1-2 sentences identifying the issue
• **Next Steps**: 2-3 bullet points max

WHEN NO IMAGE IS PROVIDED:
• Answer directly in 50-80 words max
• Reference earlier data if helpful
• No introductions or filler text

CONVERSATION RULES:
• New image → Brief analysis with extracted data
• Follow-up → Direct answer only
• Repeat image → Don't re-extract data

TONE: Professional technician, direct, solution-oriented. Never verbose.`;

// Gemini API Configuration (matching AI Studio structure)
export const GEMINI_CONFIG = {
    thinkingConfig: {
        thinkingBudget: -1,
    },
    mediaResolution: "MEDIA_RESOLUTION_MEDIUM",
    safetySettings: GEMINI_SAFETY_SETTINGS, // Use centralized safety settings
    tools: [
        {
            googleSearch: {},
        },
    ],
    systemInstruction: [
        {
            text: GEMINI_SYSTEM_INSTRUCTION,
        },
    ],
    generationConfig: {
        temperature: 0.7,
        topK: 40,
        topP: 0.95,
        maxOutputTokens: 800, // Reduced to encourage shorter responses
    },
};
